export function getAssetHost() {
  const configured = (
    process.env.REACT_APP_COMMON_ASSET_HOST ||
    process.env.REACT_APP_ASSET_HOST ||
    ''
  ).replace(/\/$/, '');

  const isUsableHost = configured && !/localhost|127\.0\.0\.1/i.test(configured);
  if (isUsableHost) {
    return configured;
  }

  if (typeof window !== 'undefined' && /hlas\.com\.sg$/i.test(window.location.hostname)) {
    return 'https://assets.hlas.com.sg';
  }

  return 'https://assets.hlassg.net';
}
